import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import lodash from "lodash";
import shortid from "shortid";

//internal components
import PublicHeaderNavigation from "../../../Common/Header/HeaderNavigation";
import BreadCrumbPanelNew from "../../../Common/BreadCrumbPanelNew";
import ImageLoader from "../../../Common/ImageLoader";
import CategoryInfo from "../Common/CategoryInfo";
import RatingStar from "../../../Common/RatingStar";
import {
  composeArrayForRatings,
  increaseViewCount,
} from "../../../Common/CommonMethods";
import SoftwareAwardCard from "../Common/SoftwareAwardCard";
import AdditionalResources from "../Common/AdditionalResources";
import TestimonialBox from "../../VendorTestimonial/TestimonialPremium/TestimonialBox";
import VendorCaseStudy from "../../VendorCaseStudy/CaseStudyPremium/VendorCaseStudy";
import VideoBox from "../../VendorVideo/VideoPremium/VideoBox";

const PremiumProfileRefresh = (props) => {
  const [isShowMore, setShowMore] = useState(false);
  const [vendorVideos, setVendorVideos] = useState({
    activeVideoPopUp: {
      isPopUpActive: false,
    },
    ...props?.vendorCommon?.corporate_video_detail,
  });

  const fallbackImages = lodash.shuffle([
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
  ]);

  const regex = /youtube.com/g;
  const isYoutube =
    !!props.vendorCommon?.corporate_video_detail?.link &&
    Boolean(props.vendorCommon?.corporate_video_detail?.link.match(regex));

  const setPopUpFalse = (location) => {
    const tempObj = {
      ...vendorVideos,
      ...location,
      activeVideoPopUp: {
        isPopUpActive: false,
      },
    };
    setVendorVideos(tempObj);
  };

  const hideShowContent = (event) => {
    event.preventDefault();
    const contentShowHide = document.querySelector(".showLessMoreContent");
    const hiddenItems = Array.prototype.slice.call(
      document.querySelectorAll(".contentHide")
    );

    const showing = contentShowHide.textContent === "Show more";

    hiddenItems.forEach(function (item) {
      if (!showing) {
        item.classList.add("content-hidden");
      } else {
        item.classList.remove("content-hidden");
      }

      contentShowHide.textContent =
        contentShowHide.textContent === "Show more" ? "Show Less" : "Show more";
    });
  };

  const CustomerReferenceRatings = (props) => {
    return (
      <>
        {!!props.vendorCommon?.rating?.aggregate_score && (
          <>
            <div class="review_rating_score">
              <div class="left">
                <span class="review_heading">Customer Rating Review Score</span>
                based on {`${props.vendorCommon.rating.rated_by_user_count}`}{" "}
                reference ratings
              </div>
              <div class="right">
                <RatingStar
                  starCount={composeArrayForRatings(
                    props.vendorCommon.rating.aggregate_score
                  )}
                  profile
                  rated_by_user_count={
                    props.vendorCommon.rating.rated_by_user_count
                  }
                />
                <div class="txt">
                  {`${props.vendorCommon.rating.aggregate_score}/5.0`}{" "}
                  <span class="total_review">
                    {`(${props.vendorCommon.rating.rated_by_user_count})`}
                  </span>
                </div>
              </div>
            </div>
          </>
        )}
      </>
    );
  };

  return (
    <>
      <PublicHeaderNavigation />

      <BreadCrumbPanelNew breadcrumbs={props.vendorProfile?.breadcrumb_links} />
      {!!props.vendorCommon &&
      !!props.vendorCommon.header_slider_images &&
      props.vendorCommon.header_slider_images.length > 0 ? (
        <section className="header_banner_section">
          <div
            className="banner_img"
            style={{
              backgroundImage: `url(${props.vendorCommon.header_slider_images[0].url})`,
              backgroundPosition: "center center",
            }}
          ></div>
        </section>
      ) : (
        ``
      )}
      <section>
        <div className="middleSection vendor_profile_section">
          <div className="container">
            <div class="vendor_profile_description">
              <div class="left_section">
                {!!props.vendorCommon &&
                !!props.vendorCommon.name &&
                !!props.vendorCommon.vendor_type &&
                props.vendorCommon.vendor_type === "premium" ? (
                  <div class="top_header">
                    <h1>{props.vendorCommon.name}</h1>
                    <span class="premiumBadge">Premium</span>
                  </div>
                ) : (
                  ``
                )}

                <div class="description_block">
                  {`Read ${
                    !!props.vendorCommon?.testimonial_count
                      ? props.vendorCommon?.testimonial_count
                      : ""
                  } ${
                    props.vendorCommon?.name
                  } reviews and testimonials from customers, explore ${
                    !!props.vendorCommon?.casestudy_count
                      ? props.vendorCommon?.casestudy_count
                      : ""
                  } case studies and customer success stories, and watch ${
                    !!props.vendorCommon?.video_count
                      ? props.vendorCommon?.video_count
                      : ""
                  } customer videos to see why companies chose ${
                    props.vendorCommon?.name
                  } as their ${props.vendorProfile?.categories[0]?.name}`}
                </div>
                {!!props.vendorCommon.logo && (
                  <div className="vendor_logo">
                    <ImageLoader
                      image={props.vendorCommon.logo}
                      fallbackImage={"/static/images/FC-Generic-Logo.webp"}
                      width={150}
                      height={45}
                    />
                  </div>
                )}

                <div className="content_block">
                  <div className={isShowMore ? "show" : "hide"}>
                    {props.vendorProfile?.description
                      .split("\r\n")
                      .map((textObj) => (
                        <p>{textObj}</p>
                      ))}
                  </div>
                  <a
                    href="#show more"
                    className="showLessMoreContent"
                    onClick={(e) => {
                      e.preventDefault();
                      hideShowContent(e);
                      setShowMore(!isShowMore);
                    }}
                  >
                    {isShowMore ? "Show less" : "Show more"}
                  </a>
                </div>
                <div class="category">
                  {props.vendorProfile.categories.length > 0 && (
                    <CategoryInfo />
                  )}
                </div>
              </div>
              <div class="right_section">
                <div class="reviews_content_block">
                  <div class="content_block">
                    <ul>
                      <li class="testimonials">
                        {!!props.vendorCommon?.testimonial_count ? (
                          <span className="number">
                            {props.vendorCommon?.testimonial_count}
                          </span>
                        ) : (
                          <span className="no_reviews">
                            {" "}
                            No <br />
                            Testimonials Yet{" "}
                          </span>
                        )}
                        <span
                          class={
                            !!props.vendorCommon?.testimonial_count
                              ? "name"
                              : "name no"
                          }
                        >
                          Testimonials
                        </span>
                        {!!props.vendorCommon?.testimonial_count && (
                          <span class="view">
                            <a href={`#testimonials-review`}>View</a>
                          </span>
                        )}
                      </li>
                      <li class="case_studies">
                        {!!props.vendorCommon?.casestudy_count ? (
                          <span className="number">
                            {props.vendorCommon?.casestudy_count}
                          </span>
                        ) : (
                          <span className="no_reviews">
                            No <br />
                            Case Studies Yet
                          </span>
                        )}
                        <span
                          class={
                            !!props.vendorCommon?.casestudy_count
                              ? "name"
                              : "name no"
                          }
                        >
                          Case Studies
                        </span>
                        {!!props.vendorCommon?.casestudy_count && (
                          <span class="view">
                            <a href={`#case-studies-review`}>View</a>
                          </span>
                        )}
                      </li>
                      <li class="videos">
                        {!!props.vendorCommon?.video_count ? (
                          <span className="number">
                            {props.vendorCommon?.video_count}
                          </span>
                        ) : (
                          <span className="no_reviews">
                            {" "}
                            No <br />
                            Videos Yet{" "}
                          </span>
                        )}
                        <span
                          class={
                            !!props.vendorCommon?.video_count
                              ? "name"
                              : "name no"
                          }
                        >
                          Customer Videos
                        </span>
                        {!!props.vendorCommon?.video_count && (
                          <span class="view">
                            <a href={`#customer-videos-review`}>View</a>
                          </span>
                        )}
                      </li>
                    </ul>
                  </div>
                  {CustomerReferenceRatings(props)}
                </div>
                <SoftwareAwardCard />
              </div>
            </div>
            <div class="more_from_attentive">
              <h2>More from {props.vendorCommon?.name}</h2>
              <ul>
                <li class="btn visit_website">
                  <a
                    href={props.vendorCommon.website}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Visit Website
                  </a>
                </li>
                {props.vendorProfile.social_urls.length > 0 && (
                  <>
                    {
                      props.vendorProfile?.social_urls
                        ?.filter((urls) => urls.platform === "linkedIn")
                        ?.map((social) => (
                          <li class="btn linkedin">
                            <a
                              href={social.url}
                              target="_blank"
                              key={`socialkey_${social.platform}`}
                              rel="noopener noreferrer"
                            >
                              LinkedIn
                            </a>
                          </li>
                        ))[0]
                    }
                    {
                      props.vendorProfile?.social_urls
                        ?.filter((urls) => urls.platform === "facebook")
                        ?.map((social) => (
                          <li class="btn facebook">
                            <a
                              href={social.url}
                              target="_blank"
                              key={`socialkey_${social.platform}`}
                              rel="noopener noreferrer"
                            >
                              Facebook
                            </a>
                          </li>
                        ))[0]
                    }

                    {
                      props.vendorProfile?.social_urls
                        ?.filter((urls) => urls.platform === "twitter")
                        ?.map((social) => (
                          <li class="btn x">
                            <a
                              href={social.url}
                              target="_blank"
                              key={`socialkey_${social.platform}`}
                              rel="noopener noreferrer"
                            >
                              X
                            </a>
                          </li>
                        ))[0]
                    }

                    {
                      props.vendorProfile?.social_urls
                        ?.filter((urls) => urls.platform === "youtube")
                        ?.map((social) => (
                          <li class="btn youtube">
                            <a
                              href={social.url}
                              target="_blank"
                              key={`socialkey_${social.platform}`}
                              rel="noopener noreferrer"
                            >
                              Youtube
                            </a>
                          </li>
                        ))[0]
                    }
                  </>
                )}
              </ul>
            </div>
            {props.vendorProfile?.featured_references?.testimonials?.length >
            0 ? (
              <div
                class="vendor_reviews_section testimonials"
                id="testimonials-review"
              >
                <h3>Featured Testimonials</h3>
                <div class="testimonial_reviews">
                  <ul>
                    {props.vendorProfile?.featured_references?.testimonials.map(
                      (reviews) => (
                        <TestimonialBox
                          key={shortid.generate()}
                          {...reviews}
                          pathname={props.location.pathname}
                          isLeadGenPopUp={
                            props.vendorProfile?.is_lead_generate_popup
                          }
                          totalRefCount={
                            props.vendorCommon?.casestudy_count
                              ? props.vendorCommon?.casestudy_count +
                                props.vendorCommon?.testimonial_count +
                                props.vendorCommon?.video_count
                              : 0
                          }
                          companyId={
                            props.vendorCommon?.company_id
                              ? props.vendorCommon?.company_id
                              : -1
                          }
                          linkedInUrl={
                            props.vendorTestimonials?.linkedin_signin_url
                          }
                        />
                      )
                    )}
                  </ul>
                </div>
                <div class="load_more_btn testimonial_btn">
                  <Link to={`/vendor/${props.match.params.id}/testimonials`}>
                    Load additional Testimonials
                  </Link>
                </div>
              </div>
            ) : null}
            {props.vendorProfile?.featured_references?.case_studies?.length >
            0 ? (
              <div
                class="vendor_reviews_section case_study"
                id="case-studies-review"
              >
                <h3>Featured Case Studies</h3>
                <div class="case_study_reviews">
                  <ul>
                    {props.vendorProfile?.featured_references?.case_studies.map(
                      (reviews) => (
                        <VendorCaseStudy
                          key={shortid.generate()}
                          {...reviews}
                          pathname={props.location.pathname}
                          isLeadGenPopUp={
                            props.vendorProfile.is_lead_generate_popup
                          }
                          totalRefCount={
                            props.vendorCommon.casestudy_count
                              ? props.vendorCommon.casestudy_count +
                                props.vendorCommon.testimonial_count +
                                props.vendorCommon.video_count
                              : 0
                          }
                          companyId={
                            props.vendorCommon.company_id
                              ? props.vendorCommon.company_id
                              : -1
                          }
                          linkedInUrl={
                            props?.vendorCaseStudies?.linkedin_signin_url
                          }
                        />
                      )
                    )}
                  </ul>
                </div>
                <div class="load_more_btn case_study_btn">
                  <Link to={`/vendor/${props.match.params.id}/case-studies`}>
                    Load additional Case Studies
                  </Link>
                </div>
              </div>
            ) : null}
            {props.vendorProfile?.featured_references?.videos?.length > 0 ? (
              <div
                class="vendor_reviews_section video"
                id="customer-videos-review"
              >
                <h3>Featured Customer Videos</h3>
                <div class="video_reviews">
                  <ul>
                    {props.vendorProfile?.featured_references?.videos.map(
                      (reviews, index) => (
                        <VideoBox
                          key={shortid.generate()}
                          {...reviews}
                          vendorName={props.vendorCommon?.name}
                          pathname={props.location?.pathname}
                          isLeadGenPopUp={
                            props.vendorProfile?.is_lead_generate_popup
                          }
                          totalRefCount={
                            props.vendorCommon?.casestudy_count
                              ? props.vendorCommon?.casestudy_count +
                                props.vendorCommon?.testimonial_count +
                                props.vendorCommon?.video_count
                              : 0
                          }
                          companyId={
                            props.vendorCommon?.company_id
                              ? props.vendorCommon?.company_id
                              : -1
                          }
                          imageIndex={fallbackImages[index % 19]}
                          linkedInUrl={props.vendorVideos?.linkedin_signin_url}
                        />
                      )
                    )}
                  </ul>
                </div>
                <div class="load_more_btn video_btn">
                  <Link to={`/vendor/${props.match.params.id}/customer-videos`}>
                    Load additional Videos
                  </Link>
                </div>
              </div>
            ) : null}
            <AdditionalResources premium />
          </div>
        </div>
      </section>
    </>
  );
};

const PremiumProfileRefreshWithRouter = withRouter(PremiumProfileRefresh);
const mapStateToProps = (state) => {
  return {
    vendorCommon: state.vendorCommon,
    vendorProfile: state.vendorProfile,
    vendorTestimonials: state.vendorTestimonials,
    vendorCaseStudies: state.vendorCaseStudies,
    vendorVideos: state.vendorVideos,
  };
};

export default connect(mapStateToProps)(PremiumProfileRefreshWithRouter);
